import { smrApi } from '@/utils/axios-config'
const apiBase = 'smr-core';

export default {
    getMonitor(params) {
        return smrApi.post(`${apiBase}/station-monitor`, params)
    },
}